import type { TmWrappers } from '@/wrappers'

export const calendarViewTypeVariant = ['month', 'week', 'day'] as const
export type CalendarViewType = (typeof calendarViewTypeVariant)[number]
export type CalendarPeriod = CalendarViewType | 'year'

export const isCalendarViewType = (value: any): value is CalendarViewType => calendarViewTypeVariant.includes(value)

export const defaultCalendarViewType: CalendarViewType = 'month'

export type CalendarState<T extends CalendarViewType = CalendarViewType> = {
  viewType: T
  date: Date
  loading: boolean
  actionsAllowed: boolean
}

export type CalendarGroupModalParams = {
  from: Date
  to: Date
  actionsAllowed: boolean
}

export const CalendarStateSymbol = Symbol('calendarState')
export const CalendarScrollHiddenSymbol = Symbol('calendarScrollHidden')

export const calendarModalId: TmWrappers = 'calendarModal'
export const calendarGroupModalId: TmWrappers = 'calendarGroupModal'
